/**
 * Centralized STG backend values (FE-STG-2 / EMS-8993).
 *
 * UNCONFIRMED — these follow the `*.stg.surecolabs.com` scheme and remain
 * placeholders until FE-STG-0 (EMS-8991) confirms them. stg is centralized here
 * (unlike dev/int/prod, which stay inline per existing convention) precisely
 * because these values are placeholders expected to change: update them in one
 * place and every stg resolver branch picks them up.
 *
 * NOTE on the `*Key` fields: like the existing dev/int/prod keys in
 * `environment.js` / `cronmail.ts`, these ship to the browser (sent as request
 * headers), so they are AWS API Gateway usage keys, not true secrets. Left as
 * `''` placeholders; real values to be supplied via FE-STG-0.
 */
export const STG_ENV = {
  // Backend hosts — confirmed `*.stg.surecolabs.com` scheme
  apiUrl: 'https://api.stg.surecolabs.com', // eps + enrollment-platform-api
  partnerBenefitGraphUrl: 'https://partner-benefit-graph.stg.surecolabs.com',
  pdfServiceUrl: 'https://pdfservice.stg.surecolabs.com', // REST; apollo appends /graphql
  enrollmeGatewayGraphqlUrl:
    'https://enrollmegateway.stg.surecolabs.com/graphql',
  vcnServiceUrl: 'https://vcn-service.stg.surecolabs.com',
  paymentServiceUrl: 'https://paymentservice.stg.surecolabs.com', // Stripe bank-links (I6)

  // TODO(FE-STG-0): unconfirmed / opaque hosts
  // partner-payment AWS gateway — empty until the stg gateway is confirmed.
  // Intentionally NOT the dev endpoint: stg must fail loudly rather than
  // silently route payment traffic at dev infrastructure.
  partnerPaymentServiceUrl: '',
  // legacy api-builder host — inert until @hixme/api-builder accepts 'stg'
  legacyApiHost: 'ni7la6mqwk.execute-api.us-west-2.amazonaws.com/stg',
  cronmailHost: 'cronmail-api-stg.hixme.com',

  // TODO(FE-STG-0): API keys (sent as client-side request headers) — '' placeholders
  paymentServiceKey: '',
  cronmailApiKey: '',

  // Microsoft Graph / SharePoint portal — same "SureCo Admin Portal (SharePoint)"
  // registration as the other environments; https://admin.stg.surecolabs.com is
  // a registered redirect URI.
  microsoftGraphClientId: '9e5f77c5-0f4b-4032-bed4-aba5a2560be7',
  microsoftGraphTenantId: 'f82bd569-15bf-4ed7-8826-f1bbf3b3fb53',
  // Optional: pins the sites the portal offers; empty lists every site the
  // signed-in user can access.
  microsoftGraphSiteIds: [] as string[],
} as const
